module.exports = __webpack_public_path__ + "static/media/tp1.9315c1dd.png";